import { FC, ReactNode } from 'react'

interface ThemeProviderProps {
	children: ReactNode
}

export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
	return <>{children}</>
}
